/* eslint-disable no-unreachable */
const wxChatMixin = {
  data () {
    return {
      device: {
        isAndroid:
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Linux') > -1,
        isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      },
    }
  },

  methods: {
    async wxInterfaceCall (currentURL, wxApi, fn) {
      try  {
        const wx = this.$wx;
        let res = await this.$api.getWxChatConfing({url: encodeURIComponent(currentURL)});
        let jsapiSignature = res.data;
        wx.config({
          debug: false,
          appId: jsapiSignature.appId,
          timestamp: jsapiSignature.timestamp.toString(),
          nonceStr: jsapiSignature.nonceStr,
          signature: jsapiSignature.signature,
          jsApiList: Array.isArray(wxApi) && wxApi.length > 0 ? wxApi : []
        });
  
        if (fn && typeof fn === 'function') {
          wx.ready(() => {
            fn(wx);
          });
          // 错误处理
          wx.error(res => {
            this.$toast.fail(res);
          })
        }
      } catch (err) {
        this.$toast.fail(err);
      }

    }
  }
}

export default wxChatMixin;